import React from 'react';
import { Mic } from 'lucide-react';

const VoiceButton = ({ isOpen, onClick }) => (
  <button
    onClick={onClick}
    title="ITRIIA Voice"
    style={{
      width: 36,
      height: 36,
      borderRadius: '50%',
      border: 'none',
      background: isOpen ? '#ea580c' : '#f97316',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s',
      boxShadow: isOpen ? '0 0 0 3px rgba(249,115,22,0.3)' : 'none',
    }}
  >
    <Mic size={18} />
  </button>
);

export default VoiceButton;
